// Utilidades para compartir con branding PlannerPRO (WhatsApp + PDF)
const BRAND_FOOTER = 'PlannerPRO · www.plannerpro.win';
const BRAND_WEB = 'www.plannerpro.win';
const DEV_FOOTER = 'Desarrollado por 7-study · www.7-study.com';
const LOGO = '/brand/logo-principal.jpg';

export function shareWhatsApp(title, lines = []) {
  const body = [`*${title}*`, '', ...lines, '', '━━━━━━━━━━━━━━', 'Enviado con *PlannerPRO*', BRAND_WEB].join('\n');
  const url = `https://wa.me/?text=${encodeURIComponent(body)}`;
  window.open(url, '_blank', 'noopener');
}

export function copyBranded(title, lines = []) {
  const body = [title, ...lines, '', 'Enviado con PlannerPRO · ' + BRAND_WEB].join('\n');
  navigator.clipboard?.writeText(body);
}

// Abre una ventana imprimible con branding para "Guardar como PDF"
export function shareBrandedPDF(title, lines = [], subtitle = '') {
  const rows = lines.map((l) => {
    if (typeof l === 'string') return `<div class="row"><span>${escapeHtml(l)}</span></div>`;
    return `<div class="row"><b>${escapeHtml(l.k)}</b><span>${escapeHtml(l.v)}</span></div>`;
  }).join('');
  const html = `<!doctype html><html lang="es"><head><meta charset="utf-8"><title>${escapeHtml(title)}</title>
  <style>
    *{box-sizing:border-box;font-family:Inter,Segoe UI,sans-serif}
    body{margin:0;background:#07090A;color:#eafff5;padding:40px}
    .card{max-width:720px;margin:0 auto;background:linear-gradient(135deg,#07090A,#123a2a);border:2px solid #3EB489;border-radius:20px;padding:36px;position:relative;overflow:hidden}
    .brandtop{display:flex;align-items:center;gap:12px;margin-bottom:8px}
    .brandtop img{width:44px;height:44px;border-radius:10px}
    .brandtop .n{font-weight:800;font-size:20px}
    .n .g{color:#C9A84C}
    h1{font-size:30px;margin:18px 0 4px}
    .sub{color:#A6C3B4;margin-bottom:22px}
    .row{display:flex;justify-content:space-between;gap:16px;padding:10px 0;border-bottom:1px solid rgba(168,230,206,.14);font-size:15px}
    .row b{color:#A8E6CE}
    .foot{margin-top:26px;padding-top:16px;border-top:1px solid rgba(168,230,206,.2);display:flex;flex-direction:column;align-items:center;gap:6px;text-align:center}
    .foot img{width:34px;height:34px;border-radius:8px;opacity:.95}
    .foot .web{color:#A8E6CE;font-weight:700;font-size:13px;letter-spacing:.3px}
    .foot .dev{color:#7fa08f;font-size:11px}
    @media print{body{background:#07090A;-webkit-print-color-adjust:exact;print-color-adjust:exact}}
  </style></head>
  <body>
    <div class="card">
      <div class="brandtop"><img src="${LOGO}" alt="logo"/><div class="n">Planner<span class="g">PRO</span></div></div>
      <h1>${escapeHtml(title)}</h1>
      ${subtitle ? `<div class="sub">${escapeHtml(subtitle)}</div>` : ''}
      ${rows}
      <div class="foot">
        <img src="${LOGO}" alt="PlannerPRO"/>
        <span class="web">${BRAND_WEB}</span>
        <span class="dev">${DEV_FOOTER}</span>
      </div>
    </div>
    <script>window.onload=()=>{setTimeout(()=>window.print(),400)}<\/script>
  </body></html>`;
  // Se usa un Blob URL (mismo origen) en lugar de document.write para evitar
  // el patrón inseguro y posibles vectores XSS. El contenido ya va escapado.
  const blob = new Blob([html], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, '_blank', 'noopener');
  if (!w) { URL.revokeObjectURL(url); return; }
  // Liberamos el objeto URL una vez cargado el documento.
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

function escapeHtml(s) {
  return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
